import type { RootState } from 'state';
import type { RoutesFiltersState } from '../slice';

function getTakeCount(state: RootState): RoutesFiltersState['takeCount'] {
  const { takeCount } = state.flightRoutes.filtersValues;
  return takeCount;
}

export default getTakeCount;
